module.exports = __webpack_public_path__ + "img/image3.1f132409.jpg";